import { JSX } from 'react';
import {
    Datagrid,
    DateField,
    FunctionField,
    List,
    ReferenceField,
    ShowButton,
    TextField,
} from 'react-admin';
import { Typography } from '@mui/material';
import { SubscriptionRefund } from "../../types/entities";
import { RefundStatusChip } from "../show/components/RefundStatusChip";
import { formatRefundAmount, notesPreview } from "../show/components/refund-format";

export const SubscriptionRefundList: () => JSX.Element = (): JSX.Element => {

    return (
        // Newest first by id: HQ-API's order filter allows `id` and not `createdAt`.
        <List actions={ false } title="Refunds" sort={ { field: 'id', order: 'DESC' } }>
            {/* HQ-22. This used to read `usePermissions()` into a variable it never looked at,
                which reads as a gate that is present. `<ShowButton>` gates itself: react-admin
                asks `authProvider.canAccess` for the show action, which answers against
                HQ_Sales::refunds. */}
            <Datagrid bulkActionButtons={ false } >
                <TextField source="id" />
                <FunctionField label="Status"
                               render={ (record: SubscriptionRefund): JSX.Element => <RefundStatusChip status={ record.status } dense /> } />
                <FunctionField label="Amount Refunded"
                               textAlign="right"
                               render={ (record: SubscriptionRefund): string => formatRefundAmount(record.currency, record.amount) } />
                <ReferenceField source="invoice" reference="subscription_invoices" label="Invoice" link="show" sortable={ false } />
                <FunctionField label="Notes"
                               render={ (record: SubscriptionRefund): JSX.Element => (
                                   <Typography variant="body2" sx={ { color: record.notes ? 'text.primary' : 'text.secondary' } }>
                                       { notesPreview(record.notes) || 'No notes' }
                                   </Typography>
                               ) } />
                <DateField source="createdAt" label="Refunded at" showTime sortable={ false } />
                <ShowButton label="View" />
            </Datagrid>
        </List>
    );
}
